export default __webpack_public_path__ + "static/media/Vue.53f5e275.jpg";